export default "__VITE_ASSET__XeGKA5_4__"